<template>
  <div class="container pb-5">
    <div class="custom-header">
      <div class="custom-header-content columns is-fullwidth mb-0">
        <TrfHeader :pageTitle="isTarefasDoCliente ? 'Dashboard do cliente' : 'Dashboard' "  :hideDivision="true" />

        <div class="column is-12-mobile is-flex is-justify-content-flex-end is-align-items-center pb-0">
          <TrfButtonSelector
            :listaDeOpcoes="opcoesTipoTarefa"
            :isAddOn="true"
            :required="true"
            class="is-fullwidth"
            id="select-tipo-tarefa"
            :podeDesmarcar="false"
            @update:opcaoSelecionada="(opcao) => (tratarTarefaSelecionada(opcao.value))"
            ref="selectTipoDeTarefa"
          />
        </div>
      </div>
      <hr />
    </div>

    <div id="dashboard-escritorio" v-if="!isTarefasDoCliente">
      <TrfSimpleModal :titulo="modalListagemTitulo" :isAtivo="modalListagemAtivo" @close="fecharModal" :isModalPersonalizado="true">
        <div id="conteudo-modal" class="modal-list-content pt-0" @scroll="TrfMixAderirAoInfiniteScroll" style="max-height:60vh; max-width:1024px; width:100%;">
          <TrfSimpleTable :configuracaoDeColunas="listagemConfiguracao"
                          :dados="listagemDados"
                          :isCliente=false
                          mensagemSemDados="Não há tarefas para este filtro."
                          :isSelectable="false"
                          :hasSlotLine="true"
                          :isToggleble="true"
                          togglebleItem="fases"
                          :isMultipleSelection="false">
            <template #tarefaNome={item}>
              <p>
                {{ item.nomePai? item.nomePai : item.nome }}<br />
                <span v-if="!!item.nomePai" class="is-italic" style="font-size:0.9em;">Fase: {{ item.nome }}</span>
              </p>
            </template>
            <template #slotLine={item}>
              <tr v-if="item.fases != null" class="is-togglable-row" style="background:#FFF!important">
                <td colspan="2" class="p-0 m-0"></td>
                <td colspan="6" class="p-0 m-0">
                  <TrfTabela
                    :containerClass="'tabela-fase-branca'"
                    :isStriped="false"
                    :dataConfig="getDataSourceFase(item.fases)"
                    :data="item.fases"
                    dataStatus=""
                    :paginacao="false"
                    :quantidadeDeItems="item.fases.length"
                    @update:pagina="(pagina) => this.atualizarPagina(pagina)"
                    :showDropdownOptions="false"
                    :isButtonsDisplayed="false"
                    :showButtonsDefault="false"
                    textoNadaEncontrado="Nenhuma fase foi encontrada."
                    :showEdit="false"
                    :isMultipleSelection="false"
                    :isSelectable="false"
                  />
                </td>
              </tr>
              <tr v-if="item.fases != null"></tr>
            </template>
          </TrfSimpleTable>
          <div v-if="TrfMixInfiniteScroll.listagemCarregando && !TrfMixInfiniteScroll.paginacaoFinalizada">
            <span class="button is-large is-fullwidth is-loading trf-is-borderless"></span>
          </div>
        </div>
      </TrfSimpleModal>

      <div>
        <div class="action-buttons buttons">
          <TrfButton
            v-e2e="'trf-dashboard-gestor-btn-relatorios'"
            id="btn-relatorios"
            nome="Relatórios"
            class="is-primary"
            v-if="podeVerRelatorios"
            @click="abrirModalGerarRelatorios"
          />
        </div>
      <div
      class="mb-1 columns is-align-items-flex-start"
      >
      <div class="column is-12-mobile">
        <div class="columns is-align-items-flex-start is-3">
          <div class="column is-12-mobile">
              <label>Departamento <span class="button is-loading is-white pl-2 pr-2 is-inline-block" style="height: 1.25em" v-if="isDepartamentosLoading"></span></label>
            <Multiselect
              :disabled="isDepartamentosLoading"
              :searchable="true"
              :options="this.listaDepartamentos"
              v-model="this.departamentoId"
              class="multiselect-econtador is-fullwidth"
              placeholder="Selecione"
              noResultsText="Departamento não encontrado"
              id="select-departamento-filtrar"
            />
          </div>

          <div class="column is-narrow-desktop is-12-mobile">
            <label>Intervalo  </label>
            <TrfButtonSelector
              :listaDeOpcoes="this.intervalosOptions"
              class="is-fullwidth"
              id="select-intervalo-filtrar"
              :podeDesmarcar="true"
              @update:opcaoSelecionada="
                (novoValor) => (this.filtroIntervalo = novoValor)
              "
              ref="filtroBotoesIntervalo"
            />
          </div>
        </div>
      </div>

      <div class="column is-3">
      </div>

      <div class="column is-narrow-desktop is-12-mobile">
        <label class="is-invisible">Filtrar</label>
        <TrfButton
          id="btn-filtrar-historico"
          nome="Filtrar"
          class="is-fullwidth is-primary"
          :class="{ 'is-loading': isTotalizadoresLoading }"
          @click="this.carregarTotalizador()"
        />

        <div class="column mt-4">
          <a @click="this.exibirFiltrosAvancados()">Filtro avançado</a>
        </div>
      </div>
    </div>

    <div class="box-filtro-avancado"  :class="{'is-hidden': !ativarFiltroAvancado}" >
      <div class=" columns is-align-items-flex-start">
        <div class="column is-6-desktop is-12-mobile">
          <label>Nome da tarefa <span
                    class="button is-loading is-light pl-2 pr-2 is-inline-block"
                    style="height: 1.25em"
                    v-if="isTarefasLoading"></span></label>
          <Multiselect
          :disabled="isTarefasLoading"
          :searchable="true"
          :options="this.listaTarefas"
          v-model="this.nomeTarefa"
          class="multiselect-econtador is-fullwidth"
          placeholder="Selecione"
          noResultsText="Tarefa não encontrada"
          id="select-nome-tarefa-dashboard-escritorio-filtrar"
        />
        </div>

        <div class="column is-6-desktop is-12-mobile">
          <label class="mb-0 has-text-centered">Data de entrega</label>
          <div class="columns is-1">
            <div class="column is-6">
              <TrfInput
                type="date"
                placeholder="DD/MM/AAAA"
                id="prazo-entrega-inicial"
                v-model="filtroDataEntregaInicial"
                ref="inputFiltroDataEntregaInicial"
                :required="false"
              />
          </div>
          <div class="column is-6">
            <TrfInput
              type="date"
              placeholder="DD/MM/AAAA"
              id="prazo-entrega-final"
              v-model="filtroDataEntregaFinal"
              ref="inputFiltroDataEntregaFinal"
              :required="false"
            />
            <div class="mensagemDeErro">
              <span v-if="deveValidarFiltroDataEntrega && !isFiltroDataEntregaValido" class="campo-obrigatório">
                Período final deve ser maior ou igual que o período inicial.
              </span>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="is-flex is-justify-content-center">
      <div class="columns is-2 is-multiline is-inline-flex is-justify-content-flex-start">
        <TrfDashboardTotalizadoresCards :totalizadores="listagemTotalizadores"/>
      </div>
    </div>
    <hr class="trf-section-divider mb-6"/>

    <DashboardGestorGraficos
      ref="graficosDashboard"
      :filtros="filtrosAplicados.filtrosRequisicaoHistorico"
      :dadosDoTotalizador="totalizadores"
      :dadosDesempenhoDasEntregas="desempenhoDasEntregas"
      :dadosAtendimentosEmAtraso="atendimentosEmAtraso"
      @action:iniciarModal="(event) => iniciarModal(event)"
    />
    <hr class="trf-section-divider mb-6"/>
    <DashboardGestorTime
      ref="timeDashboard"
      class="mt-5"
      :filtrosGlobais="filtrosAplicados.filtrosRequisicaoTime"
      :listaDepartamentos="listaDepartamentos"
    />
    </div>
    </div>
    <DashboardCliente v-else />
    <DashboardModalPermissao @on-close="(valor) => modalPermissaoDesabilitado = valor" v-if="!isTarefasDoCliente" />
    <TrfDashboardGestorModalRelatorio :isActive="isModalRelatorioActive" @trf-modal-gerar-relatorio-gestor-closed="fecharModalGerarRelatorios" />
  </div>
</template>
<script>
import TrfHeader from "../../components/Header";
import Multiselect from "@vueform/multiselect";
import TrfButton from "../../components/Button";
import TrfButtonSelector from "../../components/ButtonSelector";
import TrfSimpleModal from "../../components/Modal/TrfSimpleModal.vue"
import TrfSimpleTable from "../../components/SimpleTable"
import TrfInput from "../../components/Input"
import { utils } from "../../util/utils";
import { departamentoUtils } from "../../util/departamento.utils";
import { service } from "./service/totalizador-service";
import { toastUtils } from '../../util/toast.utils';
import { TrfMixinInfiniteScroll } from '../../mixins/infinitescroll';
import DashboardGestorGraficos from './components/DashboardGestorGraficos';
import DashboardGestorTime from './components/DashboardGestorTime/index.vue';
import DashboardModalPermissao from "./components/DashboardModalPermissao";
import { configuracoesStore } from "../../stateManagement/configuracoes";
import { liderancasStore } from "../../stateManagement/liderancas";
import TrfDashboardTotalizadoresCards from "./components/DashboardTotalizadoresCards";
import DashboardCliente from "../DashboardCliente";
import { telemetriaService } from '../../service/telemetria-service'
import { usuarioService } from "../../service/usuario-service";
import { pessoaLogada } from "../../stateManagement/pessoaLogada.js"
import TrfTabela from "../../components/Table"
import { acessoUtils } from "../../util/acesso.utils";
import { truncateText } from "../../util/intl.js";
import {totalizadoresPorTipoService} from '../../service/totalizadores-por-tipo-service';
import { defineAsyncComponent } from "vue";

export default {
  name: "DashboardGestor",
  components: {
    TrfHeader,
    Multiselect,
    TrfButton,
    TrfButtonSelector,
    TrfSimpleModal,
    TrfSimpleTable,
    TrfInput,
    DashboardGestorGraficos,
    DashboardGestorTime,
    TrfDashboardTotalizadoresCards,
    DashboardCliente,
    DashboardModalPermissao,
    TrfTabela,
    TrfDashboardGestorModalRelatorio: defineAsyncComponent(() => import('./components/DashboardGestorModalRelatorio/index.vue'))
  },
  mixins: [TrfMixinInfiniteScroll],
  data() {
    return {
      totalProcessado: 0,
      responsavelId: null,
      filtroIntervalo: "",
      departamentoId: "",
      intervalosOptions: [],
      listaDepartamentos: [],
      nomeTarefa: "",
      nomeTarefaPorTipo: "",
      listaTarefas: [],
      isTarefasLoading: true,
      isTotalizadoresLoading: true,
      isDepartamentosLoading: true,
      totalizadores: {
        aVencer: "0",
        atrasadas: "0",
        riscoDeMulta: "0",
        enviadas: "0",
        concluidas: "0",
      },
      desabilitaInteracaoComCartao: false,
      modalListagemTitulo: '',
      modalListagemAtivo: false,
      modalListagemFiltroStatus: '',
      listagemDados: [],
      listagemDadosDocumentos: [],
      opcoesTipoTarefa: [
        {
          id: "btn-dashboard-escritorio",
          label: "Dashboard do escritório",
          isSelected: true,
          value: 'escritorio'
        },
        {
          id: "btn-dashboard-cliente",
          label: "Dashboard do cliente",
          isSelected: true,
          value: 'cliente'
        },
      ],
      tipoDeTarefaSeleciocanada: 'escritorio',
      ativarFiltroAvancado: false,
      filtroDataEntregaInicial: null,
      filtroDataEntregaFinal: null,
      responsaveis: [],
      carregandoResponsaveis: true,
      permissoesTarefas: pessoaLogada.getPermissoes("Tarefas"),
      isSuperAdm: pessoaLogada.current.isSuperAdm,
      isOperadorAdmin: pessoaLogada.current.Administrador,
      filtrosAplicados: {},
      desempenhoDasEntregas: {
        concluidasEmAtraso: "0",
        concluidasNoPrazo: "0"
      },
      filtrosDesempenhoEntregas: null,
      atendimentosEmAtraso: {
        umADoisDias: "0",
        tresACincoDias: "0",
        seisAteDezDias: "0",
        onzeAteQuinzeDias: "0",
        maisDeQuinzeDias: "0",
      },
      filtroGEAtendimentos: null,
      filtroLEAtendimentos: null,
      filtroNEQAtendimentos: null,
      filtroTarefasAtendimento: null,
      tipoDeTarefaSelecionada: "escritorio",
      isModalRelatorioActive: false,
      podeVerRelatorios: false
    };
  },
  methods: {
    atualizarPagina(pagina) {
      this.pagina = pagina;
      this._carregarListagem();
    },
    getDataSourceFase(fases) {
      const dataSource = {
        columns: [
          {
            name: "nome",
            label: "Nome da fase",
            style: "width:270px;"
          },
          {
            name: "prazoEntrega",
            label: "Data de entrega",
            style: "white-space:nowrap; width:140px;",
          },
          {
            name: "departamento",
            label: "Departamento",
            style: "white-space:nowrap; width:200px;",
          },
          {
            name: "responsavel",
            label: "Responsável",
            style: "white-space:nowrap; width:160px;",
          }
        ],
        selected: null,
        itens: !!fases? fases : [],
        itensSelected: [],
        itensDisabled: [],
        filter: () => {},
        delete: (item) => this.excluir(item),
        preDelete: (item) => this.atribuirTextoExclusao(item),
        shareResponsavelEDepartamento: (item) => {
          this.objetoHistorico = item
          this.faseIdParaTransferirResponsavel = item.isFase ? item.faseId : null
          this.abrirModalTransferirResponsavel()
        },
        loadMore: null,
      };
      return dataSource;
    },
    exibirFiltrosAvancados() {
      this.ativarFiltroAvancado = !this.ativarFiltroAvancado;
    },
    tratarTarefaSelecionada(novoValor) {
      if(this.tipoDeTarefaSelecionada == novoValor) return;
      this.tipoDeTarefaSelecionada = novoValor;
      if(!this.isTarefasDoCliente) {
        this.carregarTotalizador();
      } else {
        telemetriaService.cadastrarTelemetria('dashboard-cliente');
      }
    },
    adquirirIntervaloDeHoje() {
      let hoje = utils.formatarCampoDataParaEnvioAoBackendSemHora(new Date());      
      return {
        dataInicial: hoje,
        dataFinal: hoje
      };
    },

    adquirirIntervaloSemana() {
      let hoje = new Date();
      const primeiroDia = hoje.getDate() - hoje.getDay();
      const ultimoDia = primeiroDia + 6;

      const primeiroDiaFormatado = new Date(hoje.setDate(primeiroDia)).toUTCString();
      hoje = new Date();
      const ultimoDiaFormatado = new Date(hoje.setDate(ultimoDia)).toUTCString();

      return {
        dataInicial: utils.formatarCampoDataParaEnvioAoBackendSemHora(primeiroDiaFormatado),
        dataFinal: utils.formatarCampoDataParaEnvioAoBackendSemHora(ultimoDiaFormatado)
      };
    },

    adquirirIntervaloMes() {
      const hoje = new Date();
      const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
      const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

      return {
        dataInicial: utils.formatarCampoDataParaEnvioAoBackendSemHora(primeiroDia),
        dataFinal: utils.formatarCampoDataParaEnvioAoBackendSemHora(ultimoDia)
      };
    },

    adquirirIntervaloAno() {
      const hoje = new Date() ;
      const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);;
      const primeiroDia = new Date(hoje.getFullYear() -1, hoje.getMonth(), 1);

      return {
        dataInicial: utils.formatarCampoDataParaEnvioAoBackendSemHora(primeiroDia),
        dataFinal: utils.formatarCampoDataParaEnvioAoBackendSemHora(ultimoDia )
      };
    },

    gerarIntervalos() {
      const hoje = this.adquirirIntervaloDeHoje();
      const semana = this.adquirirIntervaloSemana();
      const mes = this.adquirirIntervaloMes();

      this.intervalosOptions = [
        {
          id: "btn-filtro-intervalo-hoje",
          label: "Hoje",
          isSelected: true,
          value: hoje,
        },
        {
          id: "btn-filtro-intervalo-semana",
          label: "Esta semana",
          isSelected: false,
          value: semana,
        },
        {
          id: "btn-filtro-intervalo-mes",
          label: "Este mês",
          isSelected: false,
          value: mes,
        },
      ];
      return this.intervalosOptions;
    },
    async adquirirDepartamentos() {
      this.isDepartamentosLoading = true;
      this.listaDepartamentos = await departamentoUtils.adquirirTodosOsDepartamentos();
      this.isDepartamentosLoading = false;
      return this.listaDepartamentos;
    },
    adicionarDepartamentoQueryString(objetoQueryString) {
      if(!this.departamentoId) return objetoQueryString;

      if (this.departamentoId.includes("P")) {
        objetoQueryString.departamentoPadrao = this.departamentoId.replace("P", "");
      } else {
        objetoQueryString.departamentoId = this.departamentoId;
      }

      return objetoQueryString;
    },
    adicionarTarefaQueryString(objetoQueryString) {
      if (this.nomeTarefa) {
        objetoQueryString = this.gerarFiltroNomeTarefa(this.nomeTarefa,objetoQueryString)
      } else if (this.nomeTarefaPorTipo) {
        objetoQueryString = this.gerarFiltroNomeTarefa(this.nomeTarefaPorTipo,objetoQueryString)
      }
      return objetoQueryString;
    },
    async buscarTarefasDoEscritorio() {
      this.isTarefasLoading = true;
      const tarefasData = await this._adquirirTodasAsTarefas();
      this.listaTarefas = this._converterTarefasParaObjetoDoSelect(tarefasData);
      this.isTarefasLoading = false;
      return this.tarefas;
    },
    async _adquirirTodasAsTarefas() {
      let limit = await totalizadoresPorTipoService.listarNomes(
        this.filtroRequisicaoTarefas
      );
      const requestCustomizado = {
        ...this.filtroRequisicaoTarefas,
        limit: limit.totalDeItens
      }
      const tarefas = await totalizadoresPorTipoService.listarNomes(
        requestCustomizado
      );
      return tarefas.data;
    },
    async listarResponsaveis() {
      this.carregandoResponsaveis = true;
      this.responsaveis = await usuarioService.listarResponsaveis(true);
      this.carregandoResponsaveis = false;
      return this.responsaveis;
    },
    _converterTarefasParaObjetoDoSelect(tarefas) {
      if(!!!tarefas) return {};

      const objetoDoSelect = tarefas.map((tarefa) => {
        const option = {
          value: tarefa,
          label: tarefa
        };
        return option;
      });
      return objetoDoSelect;
    },
    async carregarTotalizador() {
      this.filtrosAplicados = {
        filtrosRequisicaoHistorico: this.filtrosRequisicaoHistorico,
        filtrosRequisicaoTime: this.filtrosRequisicaoTime
      }

      if(this.deveValidarFiltroDataEntrega && !this.isFiltroDataEntregaValido) {
        toastUtils.dangerToast("Filtro de data de entrega inválido!");
        return;
      }
      this.isTotalizadoresLoading = true;
      this.alterarLoadingsState(true);
      try {
        let filtroDeData = {};
        
        if(this.isFiltroDataEntregaValido) {
          const dataEntregaInicialFormatada = utils.formatarCampoDataParaEnvioAoBackendSemHora(this.filtroDataEntregaInicial);
          const dataEntregaFinalFormatada = utils.formatarCampoDataParaEnvioAoBackendSemHora(this.filtroDataEntregaFinal);
          filtroDeData = {
            "dataInicial": dataEntregaInicialFormatada,
            "dataFinal": dataEntregaFinalFormatada,
            "isFiltroDataDeEntrega": true
          }
        } else {
        filtroDeData = {
          "dataInicial": this.filtroIntervalo && !this.isTarefasDoCliente ? this.filtroIntervalo.value.dataInicial : '',
          "dataFinal": this.filtroIntervalo && !this.isTarefasDoCliente ? this.filtroIntervalo.value.dataFinal : '',
          }
        }
        let objetoQueryString = {
          ...filtroDeData,
          tarefaCliente: this.isTarefasDoCliente
        }
        objetoQueryString = this.adicionarDepartamentoQueryString(objetoQueryString);
        objetoQueryString = this.adicionarTarefaQueryString(objetoQueryString);
        objetoQueryString = this.renomearChave(objetoQueryString, "departamentoId", "departamento");

        this.totalizadores = await service.get(objetoQueryString);
        this.$refs.timeDashboard._carregarListagem(true);

        this.$refs.graficosDashboard.carregarPaginaDeTipo(1, true);

        await this.carregarDesempenhoDasTarefas(objetoQueryString);
        await this.carregarAtendimentosEmAtraso(objetoQueryString);

      } catch(e) {
        toastUtils.dangerToast("Ocorreu um erro ao carregar o dashboard! Tente novamente mais tarde.");
      } finally {
        this.alterarLoadingsState(false);
        this.isTotalizadoresLoading = false;
      }
    },

    async carregarDesempenhoDasTarefas(objetoQueryString) {
      const filtroDesempenhoEntregas = {
        ...objetoQueryString,
        'status':2
      }
      
      const desempenhoEntregas = await service.getDesempenhoEntregas(filtroDesempenhoEntregas);
      this.desempenhoDasEntregas.concluidasEmAtraso = desempenhoEntregas.concluidasEmAtraso;
      this.desempenhoDasEntregas.concluidasNoPrazo = desempenhoEntregas.concluidasNoPrazo;
    },

    async carregarAtendimentosEmAtraso(objetoQueryString) {
      objetoQueryString['status[NEQ]'] = 2
      objetoQueryString['atendimento_id[ISNOT]'] = null

      const filtrosAtendimentosEmAtraso = {
        ...objetoQueryString,
        'status[NEQ]':2,
        'atendimento_id[ISNOT]':null,
        'atendimento_id[NEQ]':0
    }
    
    const atendimentosEmAtraso = await service.getAtendimentosEmAtraso(filtrosAtendimentosEmAtraso);

    this.atendimentosEmAtraso.umADoisDias = atendimentosEmAtraso.umADoisDias
    this.atendimentosEmAtraso.tresACincoDias = atendimentosEmAtraso.tresACincoDias
    this.atendimentosEmAtraso.seisAteDezDias = atendimentosEmAtraso.seisAteDezDias
    this.atendimentosEmAtraso.onzeAteQuinzeDias = atendimentosEmAtraso.onzeAteQuinzeDias
    this.atendimentosEmAtraso.maisDeQuinzeDias = atendimentosEmAtraso.maisDeQuinzeDias
    },

    async iniciarModal(tipo) {
      if(!!this.desabilitaInteracaoComCartao) return;
      this.alterarLoadingsState(true);
      this.desabilitaInteracaoComCartao = true;
      let nome;
      const isTipoObject = typeof tipo === "object";
      if (isTipoObject) {
        nome = tipo.nomeString;
        tipo = tipo.targetHandler;
        this.nomeTarefaPorTipo = nome;
      } else {
        nome = "Tarefas";
      }

      const tituloAtendimentosAtrasados = 'Atendimentos atrasados:'

      switch (tipo) {
        case 'pendente':
          this.modalListagemTitulo = `${nome} com status a fazer`;
          this.modalListagemFiltroStatus = this.statusEnum.PENDENTE;
          break;
        case 'atrasada':
          this.modalListagemTitulo = `${nome} com status atrasada`;
          this.modalListagemFiltroStatus = this.statusEnum.ATRASADA;
          break;
        case 'paralisada':
          this.modalListagemTitulo = `${nome} com status paralisada`;
          this.modalListagemFiltroStatus = this.statusEnum.PARALISADA;
          break;
        case 'multa':
          this.modalListagemTitulo = `${nome} com risco de multas`;
          this.modalListagemFiltroStatus = this.statusEnum.MULTA;
          break;
        case 'enviado':
          this.modalListagemTitulo = `${nome} com documento enviado ao revisor`;
          this.modalListagemFiltroStatus = this.statusEnum.ENVIADO;
          break;
        case 'concluido':
          this.modalListagemTitulo =`${nome} com status concluído`;
          this.modalListagemFiltroStatus = this.statusEnum.CONCLUIDO;
          break;
        case 'concluidasNoPrazo':
          this.modalListagemTitulo =`${nome} concluídas no prazo`;
          this.modalListagemFiltroStatus = this.statusEnum.CONCLUIDO;
          this.filtrosDesempenhoEntregas = {
            "dataConclusao[LE]":"prazoEntrega"
          }
          break;
        case 'concluidasEmAtraso':
          this.modalListagemTitulo =`${nome} concluídas em atraso`;
          this.modalListagemFiltroStatus = this.statusEnum.CONCLUIDO;
          this.filtrosDesempenhoEntregas = {
            "dataConclusao[GT]":"prazoEntrega"
          }
          break;
        case '1-2 dias':
          this.modalListagemTitulo =`${tituloAtendimentosAtrasados} 1 a 2 dias`;
          this.filtroGEAtendimentos = {
            "prazoEntrega[GE]": this.retornarDataDiasAtras(2)
          }
          this.filtroLEAtendimentos = {
            "prazoEntrega[LE]": this.retornarDataDiasAtras(1)
          }
          break;
        case '3-5 dias':
          this.modalListagemTitulo =`${tituloAtendimentosAtrasados} 3 a 5 dias`;
          this.filtroGEAtendimentos = {
            "prazoEntrega[GE]": this.retornarDataDiasAtras(5)
          }
          this.filtroLEAtendimentos = {
            "prazoEntrega[LE]": this.retornarDataDiasAtras(3)
          }
          break;
        case '6-10 dias':
          this.modalListagemTitulo =`${tituloAtendimentosAtrasados} 6 a 10 dias`;
          this.filtroGEAtendimentos = {
            "prazoEntrega[GE]": this.retornarDataDiasAtras(10)
          }
          this.filtroLEAtendimentos = {
            "prazoEntrega[LE]": this.retornarDataDiasAtras(6)
          }
          break;
        case '11-15 dias':
          this.modalListagemTitulo =`${tituloAtendimentosAtrasados} 11 a 15 dias`;
          this.filtroGEAtendimentos = {
            "prazoEntrega[GE]": this.retornarDataDiasAtras(15)
          }
          this.filtroLEAtendimentos = {
            "prazoEntrega[LE]": this.retornarDataDiasAtras(11)
          }
          break;
        case '> 15 dias':
          this.modalListagemTitulo =`${tituloAtendimentosAtrasados} acima de 15 dias`;
          this.filtroLEAtendimentos = {
            "prazoEntrega[LT]": this.retornarDataDiasAtras(15)
          }
          break;
      }
      
      
      this.mostraLoaderDoCartaoPorTipo(tipo);

      this.filtrosAplicados.filtrosRequisicaoHistorico.status = this.modalListagemFiltroStatus;
      await this._carregarListagemModalCards(true);

      if(this.listagemDados.length > 0) {
        this.modalListagemAtivo = true;
      } else {
        this.limparFiltrosGraficos();
        toastUtils.infoToast("Não há tarefas a serem exibidas.")
      }
      this.alterarLoadingsState(false);
      this.escondeLoaderDoCartaoPorTipo(tipo);
      this.desabilitaInteracaoComCartao = false;
    },

    alterarLoadingsState(state) {
      if(!this.$refs.graficosDashboard) return;
      this.$refs.graficosDashboard.toggleLoaderDesempenhoDasEntregas(state);
      this.$refs.graficosDashboard.toggleLoaderTotalizadorDeTarefas(state);

      this.$refs.graficosDashboard.toggleLoaderAtendimentosEmAtraso(state);
      this.$refs.graficosDashboard.toggleLoaderTotalizadorPorTipoDeTarefas(state);
    },

    retornarDataDiasAtras(days) {
        const today = new Date(); 
        const resultDate = new Date(today); 
        resultDate.setDate(today.getDate() - days); 

        const year = resultDate.getFullYear();
        const month = String(resultDate.getMonth() + 1).padStart(2, '0'); 
        const day = String(resultDate.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    },

    fecharModal() {
      this.alterarLoadingsState(false);
      this.resetarPaginacao();
      this.modalListagemAtivo = false;
      this.nomeTarefaPorTipo = "";
      this.limparFiltrosGraficos();

      const conteudoComScroll = document.getElementById('conteudo-modal');
      if(!!conteudoComScroll) {
        conteudoComScroll.scrollTo(0, 0);
      }
    },
    limparFiltrosGraficos() {
      this.filtroLEAtendimentos = null;
      this.filtroGEAtendimentos = null;
      this.filtroNEQAtendimentos = null;
      this.filtroTarefasAtendimento = null;
      this.filtrosDesempenhoEntregas = null;
    },
    tratarListagem(dados) {
      if(!!!dados) return [];
      
      const listagemTratada = [];

      dados.forEach((dado) => {
        if (this.verificarTipoUsuarioETarefaDeFases(dado)) {
          const historicoDto = this.converterTarefaBackParaExibicao(dado);
          listagemTratada.push(historicoDto);
        } else {
          const fasesDto = this.converterTarefaFasesBackParaExibicao(dado, dado.fases);
          fasesDto.forEach((fase) => {
            listagemTratada.push(fase);
          })
        }
      });

      return listagemTratada;
    },
    async _carregarListagemModal(resetar) {
      this.showGlobalLoader = true;
      try {
        if (!!resetar) {
          this.resetarPaginacao();
        }

        const {historicoDashboardService} = await import('./service/historico-dashboard-service.js');

        const listaDeHistoricos = await historicoDashboardService.listarHistorico(this.filtrosAplicados.filtrosRequisicaoHistorico);
        this.totalProcessado = this.totalProcessado + listaDeHistoricos.data.length;

        this.listagemDados = [...this.listagemDados, ...this.tratarListagem(listaDeHistoricos.data)];

        const total = parseInt(listaDeHistoricos.totalDeItens);
        this.TrfMixInfiniteScroll.paginacaoFinalizada = total <= this.totalProcessado;
      } catch (e) {
        console.error(e);
      }
      this.showGlobalLoader = false;
      this.$refs.graficosDashboard.toggleLoaderTotalizadorDeTarefas(false);
    },
    async _carregarListagemModalCards(resetar) {
      this.showGlobalLoader = true;
      try {
        if (!!resetar) {
          this.resetarPaginacao();
        }

        let filtroModificado = {...this.filtrosAplicados.filtrosRequisicaoHistorico}

        filtroModificado = await this.gerarFiltrosGraficos(filtroModificado);
 
        if(this.nomeTarefaPorTipo){
          filtroModificado = this.gerarFiltroNomeTarefa(this.nomeTarefaPorTipo, filtroModificado);
        }
        filtroModificado = {...filtroModificado, pagina: this.TrfMixInfiniteScroll.page || 1}

        const {historicoDashboardService} = await import('./service/historico-dashboard-service.js');

        const listaDeHistoricos = await historicoDashboardService.listarHistoricoCards(filtroModificado);
        this.totalProcessado = this.totalProcessado + listaDeHistoricos.data.length;

        this.listagemDados = [...this.listagemDados, ...this.tratarListagem(listaDeHistoricos.data)];

        const total = parseInt(listaDeHistoricos.totalDeItens);
        this.TrfMixInfiniteScroll.paginacaoFinalizada = total <= this.totalProcessado;
      } catch (e) {
        console.error(e);
      }
      this.showGlobalLoader = false;
      this.$refs.graficosDashboard.toggleLoaderTotalizadorDeTarefas(false);
    },

    async gerarFiltrosGraficos(filtroModificado) {

      if (this.filtrosDesempenhoEntregas != null) {
          filtroModificado = {...this.filtrosAplicados.filtrosRequisicaoHistorico,...this.filtrosDesempenhoEntregas};
      }

      if (this.filtroLEAtendimentos != null || this.filtroGEAtendimentos != null) {

        this.filtroNEQAtendimentos = {
          'status[NEQ]': 2
        }

        this.filtroTarefasAtendimento = {
          'atendimento_id[isnot]': null,
          'atendimento_id[NEQ]': Number(0)
        }

        filtroModificado = {...this.filtrosAplicados.filtrosRequisicaoHistorico,
                                  ...this.filtroLEAtendimentos, 
                                  ...this.filtroGEAtendimentos,
                                  ...this.filtroNEQAtendimentos,
                                  ...this.filtroTarefasAtendimento};

      }

      return filtroModificado
    },

    montarQueryStringDocumentosIds() {
      let queryString = "";
      this.listagemDados.map((item) => {
        queryString += "filter[id]="+ item.documentoId + "&";
      })
      return queryString;
    },
    resetarPaginacao() {
      this.TrfMixInfiniteScroll.page = 1;
      this.TrfMixInfiniteScroll.limit = 100;
      this.TrfMixInfiniteScroll.paginacaoFinalizada = false;
      this.listagemDados = [];
      this.totalProcessado = 0;
    },

    async TrfMixIncrementarPagina(page, limit) {
      this.TrfMixInfiniteScroll.page = page+1;
      this.TrfMixInfiniteScroll.limit = limit;
      const request = await this._carregarListagemModalCards(false);
    },

    renomearChave(objeto, chaveAntiga, chaveNova) {
      if(!!!objeto) return {};
      if(!!!chaveAntiga || !!!chaveNova || chaveAntiga == chaveNova || !!!objeto[chaveAntiga]) return objeto;
      Object.defineProperty(objeto, chaveNova, Object.getOwnPropertyDescriptor(objeto, chaveAntiga));
      delete objeto[chaveAntiga];
      return objeto;
    },

    mostraLoaderDoCartaoPorTipo(tipo) {
      const loader = document.getElementById(`loading-card-${tipo}`);
      if(!!loader && loader.classList.contains('is-hidden')) {
        loader.classList.remove('is-hidden');
      }
    },
    escondeLoaderDoCartaoPorTipo(tipo) {
      const loader = document.getElementById(`loading-card-${tipo}`);
      if(!!loader && !!!loader.classList.contains('is-hidden')) {
        loader.classList.add('is-hidden');
      }
    },
    converterTarefaBackParaExibicao(tarefa) {
      const tarefaFormatada = {
        nome: tarefa.nome,
        empresa: `${tarefa.empresa.externoId} - ${tarefa.empresa.nome}`,
        prazoEntrega: utils.formatarDataParaExibicaoNoDataTable(tarefa.prazoEntrega),
        departamento: !!tarefa.departamentoPadrao && !!!tarefa.departamento? tarefa.departamentoPadrao.nome : tarefa.departamento.nome,
        responsavel: !!tarefa.responsavel && tarefa.responsavel.nome,
        status: tarefa.status.nome,
      }
      if (tarefa.fases != null) {
        const fasesOrdenadas = this.ordenarFases(tarefa.fases);
        const objetoDeFase = this.montarObjetoFase(fasesOrdenadas,tarefa);
        tarefaFormatada.fases = objetoDeFase;
      }
      return tarefaFormatada;
    },
    converterTarefaFasesBackParaExibicao(tarefa, fase) {
      this.ordenarFases(fase);
      const objetoDeFase = this.montarObjetoFase(fase,tarefa);
      return objetoDeFase;
    },
    verificarTipoUsuarioETarefaDeFases(historico) {
      const responsavelLogadoUWD = acessoUtils.adquirirUWDDoUsuarioLogado();
      let isTarefaDeFases = historico.fases != null;
      let isFiltroSemResponsavel = this.responsavelId == "sem responsavel" || this.responsavelId == null;
      let isTarefaSemResponsavel = historico?.responsavel?.id == "sem responsavel" || historico?.responsavel?.id == null;
      let operadorLogadoIsReponsavelDaTarefa = historico?.responsavel?.id == responsavelLogadoUWD;

      return (this.isSuperAdm) ||
        (!this.isSuperAdm && !isTarefaDeFases) ||
        (!this.isSuperAdm && isTarefaDeFases && ((isFiltroSemResponsavel && isTarefaSemResponsavel) || this.isOperadorAdmin || operadorLogadoIsReponsavelDaTarefa));
    },
    montarObjetoFase(fase,tarefa) {
      fase.map(obj => {
        const nome = obj.status.nome;
        const idFase = obj.id;
        delete obj.status;
        delete obj.id;
        obj.status = nome;
        obj.responsavel= !!!obj.responsavelId ? "---" : (this.responsaveis.find((element)=>element.value == obj.responsavelId))?.label;
        obj.dataConclusao=!!tarefa.dataConclusao?
                  utils.formatarDataParaExibicaoNoDataTable(tarefa.dataConclusao) :
                  '---';
        obj.nomePai= truncateText(tarefa.nome,49)
        obj.id= obj.historicoTarefaId,
        obj.faseId=idFase
        obj.empresa= `${tarefa.empresa.externoId} - ${tarefa.empresa.nome}`
        obj.prazoEntrega=utils.formatarDataParaExibicaoNoDataTable(tarefa.prazoEntrega)
        obj.departamento = this.exibirDepartamentoTabelaFase(obj)
      });

      return fase;
    },
    exibirDepartamentoTabelaFase(item) {
      if (!!!item.departamentoId) return "---";
      const departamento = this.listaDepartamentos.find((departamento) => {
        return departamento.value == item.departamentoId;
      });
      return departamento.label;
    },
    ordenarFases(fases) {
      fases.sort((a,b) => {
        if (a.ordem !== b.ordem) {
          return a.ordem - b.ordem;
        }
        if (a.nome < b.nome) return -1;
        if (a.nome > b.nome) return 1;
        return 0;
      });

      return fases;
    },
    gerarFiltroNomeTarefa(tarefaNome, objetoQueryString){
      if (
        tarefaNome === "Desligamento de funcionário" ||
        tarefaNome === "Agendamento de férias" ||
        tarefaNome === "Admissão do funcionário" ||
        tarefaNome === "Atendimento"
        ) {
          objetoQueryString = {
            ...objetoQueryString,
            "nome[ILIKE]": `${tarefaNome}:%`,
          };
        } else {
          objetoQueryString.nome = tarefaNome.replace(/\s/g, "%20");
        }
        return objetoQueryString;

    },
    async importDepartamentoService() {
      const { departamentoService } = await import('../../service/departamento-service.js');
      return departamentoService;
    },
    async verificarPermissaoRelatorios() {
      try {
        const pessoa = await pessoaLogada.atualizar();
        if (pessoa && (pessoa.Administrador || pessoa.isSuperAdm)) {
          this.podeVerRelatorios = true;
          return;
        }
        
        await liderancasStore.carregarLiderancas();
        const isLider = liderancasStore.isLider;
        
        this.podeVerRelatorios = isLider;
      } catch(e) {
        console.warn("WARN: Ocorreu um erro ao verificar permissões para geração do relatório");
        this.podeVerRelatorios = false;
      }
    },
    abrirModalGerarRelatorios() {
      this.isModalRelatorioActive = true;
    },
    fecharModalGerarRelatorios() {
      this.isModalRelatorioActive = false;
    }
  },
  created() {
    this.gerarIntervalos();
  },
  async mounted() {
    await this.verificarPermissaoRelatorios();
    await this.listarResponsaveis();
    await this.adquirirDepartamentos();
    this.carregarTotalizador();
    this.buscarTarefasDoEscritorio();
  },
  computed: {
    filtroRequisicaoTarefas() {
      const objetoDeFiltro = {
        limit: 1,
        pagina: 1,
        "tarefaCliente": false
      }
      return objetoDeFiltro;
    },
    isTarefasDoCliente() {
      if(this.tipoDeTarefaSelecionada == 'cliente') {
        return true;
      } else {
        return false;
      }
    },
    GerarBaixaPorLeitura() {
      return configuracoesStore.GerarBaixaPorLeitura
    },
    filtrosRequisicaoHistorico() {
      let filtroDeData = {};
      if(this.isFiltroDataEntregaValido) {
        const dataEntregaInicialFormatada = utils.formatarCampoDataParaEnvioAoBackendSemHora(this.filtroDataEntregaInicial);
        const dataEntregaFinalFormatada = utils.formatarCampoDataParaEnvioAoBackendSemHora(this.filtroDataEntregaFinal);
        filtroDeData = {
          "dataInicial": dataEntregaInicialFormatada,
          "dataFinal": dataEntregaFinalFormatada,
          "isFiltroDataDeEntrega": true
        }
      } else {
        filtroDeData = {
          "dataInicial": this.filtroIntervalo && !this.isTarefasDoCliente ? this.filtroIntervalo.value.dataInicial : '',
          "dataFinal": this.filtroIntervalo && !this.isTarefasDoCliente ? this.filtroIntervalo.value.dataFinal : '',
        }
      }
      let objetoDeFiltro = {
        "sort[ASC]": "prazoEntrega,id",
        ...filtroDeData,
        "tarefaCliente" : this.isTarefasDoCliente,
        status: this.modalListagemFiltroStatus || "",
        pagina: this.TrfMixInfiniteScroll.page || 1,
        limit: this.TrfMixInfiniteScroll.limit || 100,
      };
      objetoDeFiltro = this.adicionarDepartamentoQueryString(objetoDeFiltro);
      objetoDeFiltro = this.adicionarTarefaQueryString(objetoDeFiltro);
      objetoDeFiltro = this.renomearChave(objetoDeFiltro, "departamentoId", "departamento");
      return objetoDeFiltro;
    },
    filtrosRequisicaoTime() {
      let filtroDeData = {};
      if(this.isFiltroDataEntregaValido) {
        const dataEntregaInicialFormatada = utils.formatarCampoDataParaEnvioAoBackendSemHora(this.filtroDataEntregaInicial);
        const dataEntregaFinalFormatada = utils.formatarCampoDataParaEnvioAoBackendSemHora(this.filtroDataEntregaFinal);
        filtroDeData = {
          "dataInicial": dataEntregaInicialFormatada,
          "dataFinal": dataEntregaFinalFormatada,
          "isFiltroDataDeEntrega": true
        }
      } else {
        filtroDeData = {
          "dataInicial": this.filtroIntervalo ? this.filtroIntervalo.value.dataInicial : "",
          "dataFinal": this.filtroIntervalo ? this.filtroIntervalo.value.dataFinal : "",
        }
      }
      let objetoDeFiltro = {
        ...filtroDeData
      };
      objetoDeFiltro = this.adicionarDepartamentoQueryString(objetoDeFiltro);
      objetoDeFiltro = this.adicionarTarefaQueryString(objetoDeFiltro);
      objetoDeFiltro = this.renomearChave(objetoDeFiltro, "departamentoId", "departamento");
      return objetoDeFiltro;
    },
    statusEnum() {
      const status = {
        PENDENTE: "1",
        ATRASADA: "5",
        CONCLUIDO: "2",
        MULTA: "6",
        ENVIADO: "7",
        PARALISADA: "8"
      };
      return status;
    },
    listagemConfiguracao() {
    return [
        {
          titulo: "Nome da tarefa",
          nome: "tarefaNome",
          referencia: ['nome'],
          divisor: "",
          customStyle: "width: 325px;",
          slot: true
        },
        {
          titulo: "Nome da empresa",
          referencia: ['empresa'],
          divisor: ` - `,
          customStyle: "width:255px;"
        },
        {
          titulo: "Data de entrega",
          referencia: ['prazoEntrega'],
          divisor: "",
          customStyle: "width: 140px;"
        },
        {
          titulo: "Departamento",
          referencia: ['departamento'],
          divisor: "",
          customStyle: "width: 200px;"
        },
        {
          titulo: "Responsável",
          referencia: ['responsavel'],
          divisor: "",
          customStyle: "width: 160px;"
        }
      ]
    },
    listagemTotalizadores() {
      return [
        {
          id: "card-pendente",
          tipo: "pendente",
          nome: "A fazer",
          quantidade: this.totalizadores.aVencer,
          cor: "#5692E6",
          icone: "list",
          isLoading: this.isTotalizadoresLoading,
          isCardSempreVisivel : true,
          acao: () => this.iniciarModal('pendente')
        },
        {
            id: "card-atrasa",
            tipo: "atrasada",
            nome: "Atrasadas",
            quantidade: this.totalizadores.atrasadas,
            cor: "#E33B3C",
            icone: "triangle-exclamation",
            isLoading: this.isTotalizadoresLoading,
            isCardSempreVisivel : true,
            acao: () => this.iniciarModal('atrasada')
        },
        {
            id: "card-paralisada",
            tipo: "paralisada",
            nome: "Paralisadas",
            quantidade: this.totalizadores.paralisadas,
            cor: "#666666",
            icone: "pause",
            isLoading: this.isTotalizadoresLoading,
            isCardSempreVisivel : true,
            acao: () => this.iniciarModal('paralisada')
        },
        {
            id: "card-multa",
            tipo: "multa",
            nome: "Risco de multas",
            quantidade: this.totalizadores.riscoDeMulta,
            cor: "#C8B71B",
            icone: "sack-dollar",
            isLoading: this.isTotalizadoresLoading,
            isCardSempreVisivel : true,
            acao: () => this.iniciarModal('multa')
        },
        {
            id: "card-enviado",
            tipo: "enviado",
            nome: "Enviado",
            quantidade: this.totalizadores.enviadas,
            cor: "#547faa",
            icone: "envelope",
            isLoading: this.isTotalizadoresLoading,
            isCardSempreVisivel : this.GerarBaixaPorLeitura && this.totalizadores.enviadas != undefined,
            acao: () => this.iniciarModal('enviado')
        },
        {
            id: "card-concluido",
            tipo: "concluido",
            nome: "Concluído",
            quantidade: this.totalizadores.concluidas,
            cor: "#32AA45",
            icone: "check",
            isLoading: this.isTotalizadoresLoading,
            isCardSempreVisivel : true,
            acao: () => this.iniciarModal('concluido')
        }
      ]
    },

    isFiltroDataEntregaValido() {
      const filtroInicialAsDate = new Date(this.filtroDataEntregaInicial);
      const filtroFinalAsDate = new Date(this.filtroDataEntregaFinal);

      const isDataEntregaPreenchida = !!this.filtroDataEntregaInicial && !!this.filtroDataEntregaFinal;
      const isDataEntregaValida = filtroInicialAsDate instanceof Date && isNaN(this.filtroDataEntregaInicial) && filtroFinalAsDate instanceof Date && isNaN(this.filtroDataEntregaFinal);
      const isIntervaloValido = this.filtroDataEntregaFinal >= this.filtroDataEntregaInicial;

      return isDataEntregaPreenchida && isDataEntregaValida && isIntervaloValido;
    },

    deveValidarFiltroDataEntrega() {
      return !!this.filtroDataEntregaInicial || !!this.filtroDataEntregaFinal;
    },

  },
  watch: {
    filtroDataEntregaInicial(valorNovo) {
      if(!!!valorNovo && !!!this.filtroDataEntregaFinal && this.$refs.filtroBotoesIntervalo.valor == null) {
        this.$refs.filtroBotoesIntervalo._selecionarDefault();
      } else if(!!valorNovo) {
        this.$refs.filtroBotoesIntervalo.valor = null;
      }
    },
    filtroDataEntregaFinal(valorNovo) {
      if(!!!valorNovo && !!!this.filtroDataEntregaInicial && this.$refs.filtroBotoesIntervalo.valor == null) {
        this.$refs.filtroBotoesIntervalo._selecionarDefault();
      } else if(!!valorNovo) {
        this.$refs.filtroBotoesIntervalo.valor = null;
      }
    }
  }
};
</script>
<style lang="scss">
  .trf-is-borderless {
    border:0 none!important;
    outline: 0 none!important;
  }
</style>
<style lang="scss" scoped>
  .trf-is-borderless {
    border:0 none!important;
    outline: 0 none!important;
  }
.multiselect-econtador {
  margin: 0;
}

.columns.is-0 > .column {
  padding-left: 0;
  padding-right: 0;
}
.columns.is-1 > .column {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.columns.is-3 > .column {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.columns.is-4 > .column {
  padding-left: 1rem;
  padding-right: 1rem;
}
.columns.is-5 > .column {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.columns.is-6 > .column {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.columns.is-7 > .column {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.columns.is-8 > .column {
  padding-left: 2rem;
  padding-right: 2rem;
}

.modal-list-content {
  padding: 8px 35px;
  overflow:auto;
  height:100%;
}

@media screen and (max-width: 1023px) {
  .columns.is-multiline {
    display:flex;
  }
}

.box-filtro-avancado {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
}
</style>
<style lang="scss">
  .tabela-fase-branca table tr {
    background:#FFF!important;
    &:hover {
      background: hsl(0deg, 0%, 96%)!important;
    }
  }
  table {
    .is-toggle-action {
      position:relative;
      input[type=checkbox] {
        opacity:0;
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        pointer-events: none;
      }
    }
    & > tr, & > tbody > tr, & > thead > tr {
      & + .is-togglable-row {
        tr, th, td, th  > *, td > * {
          max-height:0;
          overflow:hidden;
          padding-top:0;
          padding-bottom:0;
          margin-top:0;
          margin-bottom:0;
          transition: overflow 0s ease-out 0.35s, 0.35s ease-out 0s;
        }
      }
      &.is-toggled + .is-togglable-row {
        tr, th, td, th  > *, td > * {
          max-height:1000vh;
          overflow:visible;
          transition: overflow 0s ease-in 0.35s, 0.35s ease-in 0s;
        }
      }
    }
  }
</style>
